import React, { useEffect, useState } from 'react';
import { Button, Progress } from 'antd';
import { DownloadOutlined, RedoOutlined } from '@ant-design/icons';
import { useDownloadManager } from '../../contexts/DownloadManagerContext';
import { useTranslation } from 'react-i18next';
import { useBrowser } from '../../contexts/BrowserContext';
import getProfileType from '../../helpers/getProfileType';
import { GetClientType } from '../../config';

const DownloadButton = ({ indexAssets,product, className }) => {
    const { t } = useTranslation();

    const { handleDownload, downloadList, downloadListChanged, DownloadStates, checkDownloadState, getDownloadProgress } = useDownloadManager();
    const [status, setStatus] = useState(DownloadStates.NotDownloaded);
    const [fileSize, setFileSize] = useState(0);
    const { getFilePath,getFileinfo } = useBrowser();
    const getFileSize = async (product)=>{
        const type = getProfileType(product)

        const filePath = await getFilePath(product,type);

        const fileInfo =  await getFileinfo(filePath,type);
        if(GetClientType() == "revit"){
            const info = JSON.parse(fileInfo)
           setFileSize(info?.size)
            
        }else{
            setFileSize(fileInfo?.size);
            
        }
        setStatus(checkDownloadState(product));

    }
    useEffect(() => {
        setStatus(checkDownloadState(product));
        
        getFileSize(product)
        
    }, [product?.id, downloadListChanged,status]);

    return (
        <div className={className ?? ""}>
            {(status === DownloadStates.NotDownloaded  || ( status === DownloadStates.Finished &&  fileSize !== product?.assets[0]?.size_in_bytes) ) && (
                <Button type="primary" size='large' style={{ backgroundColor: "#49be78" }} icon={<DownloadOutlined />}
                    onClick={() => handleDownload(product,indexAssets)}>
                    {t('download.start_download')}
                </Button>
            )}

            {status === DownloadStates.Downloading && (
                <Button type="primary" size='large' icon={<DownloadOutlined />}
                    onClick={() => handleDownload(product,indexAssets)}>
                    {t('download.stop')}
                </Button>
            )}

            {status === DownloadStates.Finished && fileSize === product?.assets[0]?.size_in_bytes && (
                
                <Button type="primary" size='large' style={{ backgroundColor: "#2F3847" }} icon={<RedoOutlined />}
                    onClick={() => handleDownload(product,indexAssets)}>
                         {t('download.download_again')}
                </Button>
            )}


            {(status === DownloadStates.Paused || status === DownloadStates.Failed) && (
                <Button type="primary" size='large' style={{ backgroundColor: "#d90" }} icon={<RedoOutlined />}
                    onClick={() => handleDownload(product,indexAssets)}>
                    {t('download.resume')}
                </Button>
            )}

            {(status === DownloadStates.Downloading ||
             status === DownloadStates.Paused 
               )&& (
                <div>
                    <Progress percent={getDownloadProgress(product)} size="small" status="active" showInfo={true} />
                </div>
            )}
         
        </div>
    );
};

export default DownloadButton;
